import LoaderReviewersDetails from '../components/reviewers-detail-page/LoaderReviewersDetails'
import ReviewersDetails from '../components/reviewers-detail-page/ReviewersDetails'
import useReviewer from '../hooks/useReviewer'

export default function ReviewersDetailPage() {
  const { reviewer, isLoading } = useReviewer()

  return (
    <div className="flex w-full flex-col gap-2">
      {isLoading ? (
        <LoaderReviewersDetails />
      ) : (
        <ReviewersDetails reviewer={reviewer} />
      )}
    </div>
  )
}
